module.exports = __webpack_public_path__ + "img/module_khdgl_icon.59913de5.png";